import { useMemo } from 'react';

import { Dropdown, DropdownProps } from 'primereact/dropdown';

import { useGetOptionSetsByNameQuery } from '@/app/services/lookups';
import { OptionSet } from '@/rtk-query.gql';

type OptionSetsDropdownProps = DropdownProps & {
  label?: string;
  optionSetsName?: string;
  filterOptions?: (item: OptionSet) => boolean;
};

export const OptionSetsDropdown = ({
  label,
  optionSetsName,
  filterOptions,
  ...dropdownProps
}: OptionSetsDropdownProps) => {
  const { data = [], isLoading } = useGetOptionSetsByNameQuery(
    optionSetsName ?? '',
  );

  const options = useMemo(() => {
    const filtered = filterOptions ? data.filter(filterOptions) : data;
    return filtered.map((item: OptionSet) => ({
      label: item.label,
      value: item.id,
    }));
  }, [data, filterOptions]);

  return (
    <div className={`option-sets-dropdown${label ? 'label-input-group' : ''}`}>
      {label && <label>{label}</label>}
      <Dropdown
        appendTo="self"
        options={options}
        filterPlaceholder="Search"
        filter
        filterInputAutoFocus={true}
        loading={isLoading}
        showClear
        {...dropdownProps}
      />
    </div>
  );
};
